import { initMobileNavigation } from './navigation.js';
import { initModalAccessibility } from './a11y.js';
import { initHeaderSearch } from './search.js';
import { initScrollHeader } from './scroll-header.js';
import { initUserAccount } from './user.js';
import { initAsyncForms } from './forms.js';
import { initLoginOverlay } from './login-overlay.js';
import { initCommentDraftPersistence } from './comment-draft.js';

$(document).ready(function () {
	console.log('init.js loaded');

	$.ajax({
		url: '/secretnews/img/sprite/sprite.svg',
		type: 'GET',
		dataType: 'text',
		success: function(data) {
			$('body').prepend('<div class="svg-sprite" style="display: none; position: absolute; width: 0; height: 0;">' + data + '</div>');
		},
		error: function(xhr, status, error) {
			console.error('Fehler beim Laden des SVG-Sprites:', error);
		}
	});

	initMobileNavigation();
	initModalAccessibility();
	initHeaderSearch();
	initScrollHeader();
	initUserAccount();
	initAsyncForms();
	initLoginOverlay();
	initCommentDraftPersistence();
});